var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['page-card', { sm: _vm.sm }]},[(_vm.title)?_c('h2',{staticClass:"page-card-title px-2 pt-2"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),(_vm.hr)?_c('hr',{staticClass:"my-3"}):_vm._e(),_c('div',{staticClass:"page-card-content p-2"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }